module.exports = __webpack_public_path__ + "img/1.1059a0bf.png";